import * as React from "react";
import { Header, Divider, List, Message } from "semantic-ui-react";

export const Home = () => {
  return (
    <div>
      <p>本サイトはWebアプリのポートフォリオサイトです。リンク先がないページは現在準備中です。</p>

      <Header as="h2">アプリ一覧</Header>
      <Divider />

      <Header as="h3">確率思考の戦略論</Header>
      <List bulleted>
        <List.Item href='/article/mkt/nbd'>負の二項分布</List.Item>
        <List.Item href='/article/mkt/gamma'>ガンマ分布</List.Item>
        <List.Item href='/article/mkt/dirichlet'>デリシュレーのNBD</List.Item>
      </List>

      {/* <Header as="h3">量子コンピュータ</Header>
      <List bulleted>
        <List.Item href=''>blueqat</List.Item>
      </List>

      <Header as="h3">数理最適化</Header>
      <List bulleted>
        <List.Item href=''>線形計画法</List.Item>
        <List.Item href=''>シンプレックス法</List.Item>
      </List>

      <Header as="h3">数値シミュレーション</Header>
      <List bulleted>
        <List.Item href=''>モンテカルロシミュレーション</List.Item>
      </List> */}

      <Header as="h3">画像認識</Header>
      <List bulleted>
        <List.Item href=''>顔の認識</List.Item>
        <List.Item href=''>視線の解析</List.Item>
      </List>

      {/* <Header as="h3">自然言語処理</Header>
      <List bulleted>
        <List.Item href=''>アンケート解析</List.Item>
      </List>

      <Header as="h3">待ち行列</Header> */}


      <Header as="h3">サーバー構成</Header>
      <List bulleted>
        <List.Item href='https://ja.wayama.io/article/system/wa_app_blog_arch/'>アーキテクチャ</List.Item>
      </List>

    </div>
  );
};

export default Home;
